/* global $ */

const $list = $('.js-dates-list');
const $toggle = $('.js-dates-list-extend');
const $items = $('.js-dates-list-item');

const datesList = {
  initialize() {
    if ($list.length) {
      this.initialListLength = parseInt($list.data('show-initial'), 10);
      this.createEvents();
    }
  },

  createEvents() {
    $toggle.on('click', () => {
      this.toggle();
    });
  },

  toggle() {
    this[$toggle.hasClass('is-expanded') ? 'hide' : 'show']();
    $toggle.toggleClass('is-expanded');
  },

  show() {
    $items.show().removeClass('d-none');
    $items.eq(this.initialListLength).focus();
    $toggle.data('dates-more', $toggle.text());
    $toggle.text($toggle.data('dates-less'));
  },

  hide() {
    $toggle.focus();
    $items.filter(`:nth-child(1n + ${this.initialListLength + 1})`).hide();
    $toggle.text($toggle.data('dates-more'));
  },
};

export default datesList;
